/** @jsxImportSource @emotion/react */
import React from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import * as size from '@constant/size';
import * as color from '@constant/color';
import Content from '@component/common/content';
import SideTab from '@component/admin/navigator/side-tab';
import HeaderContainer from '@component/common/architecture/header/header-container';
import TextBlock from '@component/common/block/text-block';
import IconBlock from '@component/common/block/icon-block';

interface IProps {
  title: string;
  mode?: 'page' | 'back';
  children: React.ReactNode;
  backgroundColor?: string;
  handleBackClick?: () => void;
}

const HEADER_ICON_DESIGN = {
  icon: { size: 'medium' },
  box: { width: '30px', left: '15px', event: { cursor: 'pointer' } },
} as const;

const HEADER_CONTAINER_DESIGN = {
  left: size.WEB_SIDE_WIDTH,
  right: '0px',
  height: size.WEB_HEADER_HEIGHT,
  align: 'right',
  backgroundColor: color.WHITE_1,
  boxShadow: color.HEADER_SHADOW,
  zIndex: 10,
} as const;

const HEADER_TEXT_DESIGN = {
  text: { size: 'medium', color: color.BLACK_2 },
  box: { top: '50%', left: '50%', transform: 'translate(-50%, -50%)' },
} as const;

const PageTemplate: React.FC<IProps> = ({
  title,
  children,
  mode = 'page',
  backgroundColor = color.GRAY_BACKGROUND_COLOR,
  handleBackClick,
}) => {
  const navigate = useNavigate();
  const onBackClick = () => (handleBackClick ? handleBackClick() : navigate(-1));

  return (
    <>
      <Helmet>
        <title>{`${title} - Otterbrick Admin`}</title>
      </Helmet>
      <SideTab />
      <HeaderContainer design={HEADER_CONTAINER_DESIGN}>
        {mode === 'back' && <IconBlock icon='back' design={HEADER_ICON_DESIGN} click={{ handler: onBackClick }} />}
        <TextBlock text={title} design={HEADER_TEXT_DESIGN} />
      </HeaderContainer>
      <Content
        left={size.WEB_SIDE_WIDTH}
        top={size.WEB_HEADER_HEIGHT}
        bottom='0px'
        backgroundColor={backgroundColor}>
        {children}
      </Content>
    </>
  );
};

export default PageTemplate;
